import { API_URL } from "../utils/auth";

export async function fetchPublicMonthlySpecials({ signal, featured } = {}) {
  const params = new URLSearchParams();
  if (featured !== undefined) params.set("featured", featured ? "true" : "false");
  const query = params.toString();
  const response = await fetch(`${API_URL}/monthly-specials/public/${query ? `?${query}` : ""}`, {
    headers: { Accept: "application/json" },
    signal,
  });
  if (!response.ok) throw new Error("Monthly specials could not be loaded.");
  const data = await response.json();
  return Array.isArray(data) ? data : [];
}
